const { getById, getAll } = require( "@/utilities/querySelector" );

/**
 * Toggles elements aria-hidden attributes based on aria-controls
 */
document.addEventListener( 'DOMContentLoaded', function() {
    getAll( '[data-toggles]' ).forEach( function( toggleElement ) {
        toggleElement.addEventListener( 'click', function( event ) {
            event.preventDefault();
            const targetId = toggleElement.getAttribute( 'aria-controls' );
            if ( !targetId ) return console.warn( 'No aria-controls attribute found on toggle element.' );
            const targetElement = getById( targetId );

            if ( targetElement ) {
                toggle( targetElement, toggleElement );
            } else {
                console.warn( `Element with ID "${targetId}" not found. [data-toggles]` );
            }
        } );
    } );

    getAll( '.mobile-menu .menu-item-has-children > .sub-menu' ).forEach( function( subMenu ) {
        subMenu.setAttribute( 'aria-hidden', 'true' );
    } );

    getAll( '.menu-item-has-children > .submenu-toggle' ).forEach( function( toggler ) {
        toggler.addEventListener( 'click', function( e ) {
            e.preventDefault();
            const targetEl = toggler.parentElement.querySelector( ':scope > .sub-menu' );

            if ( targetEl ) {
                toggle( targetEl, toggler );
            } else {
                console.warn( `Sub menu not found. [submenu-toggle]` );
            }
        } );
    } );
} );

/**
 * @param {HTMLElement} el
 * @param {HTMLElement} toggler
 *
 * @return void
 */
function toggle( el, toggler ) {
    const isHidden = el.getAttribute( 'aria-hidden' ) === 'true';
    el.setAttribute( 'aria-hidden', ( !isHidden ).toString() );
    toggler.setAttribute( 'aria-expanded', isHidden.toString() );
}